import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAventrixComponent } from './simple-icons-aventrix.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAventrixComponent ],
    exports:      [ SimpleIconsAventrixComponent ],
    bootstrap:    []
})
export class SimpleIconsAventrixModule {}
